<div #plotDiv class="flex-item-fill overflow-y-auto width100p height100p"></div>
<div #xAxisDiv class="x-axis flex-item-fixed width100p"></div>
